$(document).ready(function() {
  if (window.location.href.indexOf("a/buy") > -1) {
  	var cities = ['adelaide','sydney','perth','brisbane'];
    $.each( cities, function(i, val ) {
      if (window.location.href.indexOf(val) > -1) {
        $('.filter-menu, .filter-group, .close-filter').remove();
      }
    });
  }
  /*
  if (window.location.href.indexOf("collections/dining-tables") > -1) {
  	var tables = ['4-seater, 6-seater','8-seater'];
    $.each( tables, function(i, val ) {
      if (window.location.href.indexOf(val) > -1) {
        $('.filter-menu, .filter-group, .close-filter').remove();
      }
    });
  }*/
  var breaking = $('.site-header').height();
  $(window).scroll(function() {
    var scrolltop = $(window).scrollTop();
    //if($(window).width() > 600) {
      if (scrolltop > breaking ) {
        $('a.snize-sticky-searchbox').css("display", "block");
      } else {
        $('a.snize-sticky-searchbox').css("display", "none");
      }
   // } 
    
    /*if($(window).width() < 600) {
      if (scrolltop > breaking ) {
        $('.c-snize-sticky-searchbox').css("display", "block");
      } else {
        $('.c-snize-sticky-searchbox').css("display", "none");
      }
    }*/
  });

/*window.addEventListener("DOMContentLoaded", (event) => {
    const el = document.getElementById('m-floating-search');
    if (el) {
      el.addEventListener('click', function(e){
         console.log('herer');
         $('.snize-ac-results-mobile').attr('style', 'display: block');
      });
    }
});

  if($(window).width() < 600) {
    $("a.snize-custom-widget-opener").attr('style', 'display: none !important');
    $("a.snize-custom-widget-opener").click(function(event){
       event.preventdefault();
    });
  }*/
});